import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { adminBrandQuery } from '../../graphql/queries';
import {
  TabsComponentBootstrap,
  LoadingContainer,
} from '../../components/Layout';
import { MerchantEditGeneralInfoTab } from '../../views/MerchantComponents/MerchantEditGeneralInfoTab';
import { MerchantEditBillingInfoTab } from '../../views/MerchantComponents/MerchantEditBillingInfoTab';
import { MerchantEditInvoiceSettingsTab } from '../../views/MerchantComponents/MerchantEditInvoiceSettingsTab';
import { BrandChangeHistory } from '../../views/MerchantComponents/BrandChangeHistory';
import { getActiveTabFromNav } from '@/utils/url';
import i18n from '@/utils/i18n';
import { FaInfoCircle, FaFileInvoice, FaCog, FaHistory } from 'react-icons/fa';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function MerchantEditPage() {
  const { brandId } = useParams<{ brandId: string }>();
  const urlParams = new URLSearchParams(window.location.search);
  const activeTabParam = urlParams.get('activeTab');
  const activeTab = activeTabParam !== null ? activeTabParam : '0';

  const { data = { brand: null }, loading: loadingBrand } = useQuery(
    adminBrandQuery,
    {
      fetchPolicy: 'no-cache',
      variables: { id: brandId },
    },
  );

  const brandName = data.brand?.name || '';
  useDocumentTitle('PageTitles:brand', brandName);

  if (loadingBrand || !data.brand) {
    return (
      <div className="mt-3">
        <LoadingContainer />
      </div>
    );
  }

  const tabs = [
    {
      title: i18n.t('Common:generalInfo'),
      icon: <FaInfoCircle />,
      content: (
        <MerchantEditGeneralInfoTab externalPickpackId={brandId || null} />
      ),
    },
    {
      title: i18n.t('Billing:billingInfo'),
      icon: <FaFileInvoice />,
      content: (
        <MerchantEditBillingInfoTab externalPickpackId={brandId || null} />
      ),
    },
    {
      title: i18n.t('Billing:invoiceSettings'),
      icon: <FaCog />,
      content: (
        <MerchantEditInvoiceSettingsTab externalPickpackId={brandId || null} />
      ),
    },
    {
      title: i18n.t('Tabs:changeHistory'),
      icon: <FaHistory />,
      content: (
        <BrandChangeHistory
          brandTextId={brandId || ''}
          title={i18n.t('Tabs:changeHistory')}
        />
      ),
    },
  ];

  return (
    <div className="mt-5">
      <h3 className="d-inline-block me-3">{brandName}</h3>
      <TabsComponentBootstrap
        className="mb-4 mt-3"
        tabs={tabs}
        activeTab={activeTab}
      />
    </div>
  );
}
